import React, { useState } from "react";
import { Table, Input, Select, Spin, DatePicker } from "antd";
import dayjs from "dayjs";
import _ from "lodash";

import CustomCalendar from "../../components/calendar";
import { useDispatch, useSelector } from "react-redux";
import { setStorage } from "./redux/actions";
import moment from "moment";

const HistoryTable = ({ notificationHistoryList, ...rest }) => {
  const { allNotifications, loading } = useSelector(
    (state) => state.notificationManagerReducer
  );

  const [sortedInfo, setSortedInfo] = useState(rest.sortedInfo || null);
  const [search, setSearch] = useState({});
  const [defaultPageOneReq, setDefaultPageOneReq] = useState(false);

  const [date, setDate] = useState(null);
  const [dateSent, setDateSent] = useState(null);
  const [datePickerOpened, setDatePickerOpened] = useState(false);

  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState({
    subject: "",
    body: "",
    first_name: "",
    last_name: "",
    recipientType: "",
    response: "",
    dateSent: "",
  });

  const handleSearch = (key, value) => {
    setSearchText((prev) => ({
      ...prev,
      [key]: value.toLowerCase(),
    }));
  };

  const filteredData = notificationHistoryList
    ?.map((item, index) => ({
      key: index,
      subject: item.title || "N/A",
      body: item.body || "N/A",
      recipientType: item?.recipientType || "Unknown",
      first_name: item?.recipient?.first_name || "",
      last_name: item?.recipient?.last_name || "",
      response: item.status || "Pending",
      dateSent: item.createdAt
        ? dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")
        : "N/A",
    }))
    .filter((item) =>
      Object.keys(searchText).every((key) =>
        item[key]?.toString().toLowerCase().includes(searchText[key])
      )
    );

  const columns = [
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">DATE SEND</div>
            <div>
              <DatePicker
                onChange={(date, dateString) =>
                  handleSearch("dateSent", dateString)
                }
                allowClear
                style={{ width: "100%" }}
                // placeholder="Select date"
                format="YYYY-MM-DD"
                suffixIcon={null}
              />
            </div>
          </div>
        );
      },
      dataIndex: "dateSent",
      key: "dateSent",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "dateSent" && sortedInfo?.order,
      ellipsis: true,
      width: "30%",
      align: "left",
      render: (dateSent) => {
        if (!dateSent || dateSent === "N/A") {
          return "N/A";
        }

        return moment
          .utc(dateSent, "YYYY-MM-DD HH:mm:ss.SSS")
          .local()
          .format("DD MMM YYYY hh:mm A");
      },
    },

    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">first name</div>
            <div>{searchInput("first_name")}</div>
          </div>
        );
      },
      dataIndex: "first_name",
      key: "first_name",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "first_name" && sortedInfo?.order,
      ellipsis: true,
      width: "20%",
      render: (first_name, { _id }) => <div>{first_name}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">last name</div>
            <div>{searchInput("last_name")}</div>
          </div>
        );
      },
      dataIndex: "last_name",
      key: "last_name",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "last_name" && sortedInfo?.order,
      ellipsis: true,
      width: "20%",
      render: (last_name, { _id }) => <div>{last_name}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">title</div>
            <div>{searchInput("subject")}</div>
          </div>
        );
      },
      dataIndex: "subject",
      key: "subject",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "subject" && sortedInfo?.order,
      ellipsis: true,
      width: "20%",
      render: (title, { _id }) =>
         <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >{title}</div>,
    },

    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">body</div>
            <div>{searchInput("body")}</div>
          </div>
        );
      },
      dataIndex: "body",
      key: "body",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "body" && sortedInfo?.order,
      ellipsis: true,
      width: "20%",
      render: (body, { _id }) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {body}
        </div>
      ),
    },

    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">Recipient type</div>
            <div>{searchInput("recipientType")}</div>
          </div>
        );
      },
      dataIndex: "recipientType",
      key: "recipientType",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "recipientType" && sortedInfo?.order,
      ellipsis: true,
      width: "20%",
      render: (recipientType, { _id }) => (
        // <div>{recipientType ?  recipientType.toUpperCase() : ""}</div>,
        <div>
          {recipientType
            ? recipientType.charAt(0).toUpperCase() +
              recipientType.slice(1).toLowerCase()
            : ""}
        </div>
      ),
    },

    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">Status</div>
            <div>{searchInput("response")}</div>
          </div>
        );
      },
      dataIndex: "response",
      key: "response",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "response" && sortedInfo?.order,
      ellipsis: true,
      width: "20%",
      render: (response, { _id }) => (
        // <div>{response}</div>,
        <div>
          {response
            ? response.charAt(0).toUpperCase() + response.slice(1).toLowerCase()
            : ""}
        </div>
      ),
    },
  ];

  const capitalizeText = (text) => {
    return text
      ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
      : text;
  };

  const searchInput = (key) => (
    <Input
      onClick={(e) => e.stopPropagation()}
      value={search[key]}
      onChange={(e) => {
        handleSearch(key, e.target.value, debouncedDefaultPageOneCallApi);
      }}
    />
  );

  const [debouncedDefaultPageOneCallApi] = useState(() =>
    _.debounce(() => setDefaultPageOneReq((prev) => !prev), 1000)
  );

  return (
    <Spin spinning={loading}>
      <Table
        className="special-table users-manager-table"
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
      />
    </Spin>
  );
};

export default HistoryTable;
